<div [id]="idModal" class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Enviar e-mail do {{entity?.tipoVenda | pedidoTipoVendaSinonimo}} {{entity?.numero}}
                </h4>
            </div>

            <div class="modal-body" *ngIf="config?.isLoading">
                <p class="text-muted mb-0">
                    <i class='fas fa-spinner fa-pulse'></i> Carregando
                </p>
            </div>

            <ng-template [ngIf]="config?.isOpen && valueObject">
                <div class="modal-body">
                    <form #form="ngForm" novalidate>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="to" class="col-form-label">Para</label>
                                <sgt-tokenfield
                                    [(ngModel)]="valueObject.to"
                                    name="to"
                                    id="to"
                                    [createTokensOnBlur]="true"
                                    inputType="email"
                                    tokenDuplicateMessage='E-mail do destinatário já adicionado'
                                    [validateEmail]="true"
                                    required="required"
                                    #to="ngModel"
                                    #toTokenfield
                                    (createdtoken)="onCreateContatoTo($event)"
                                    (removedtoken)="onRemoveContatoTo($event)"
                                    [ngControl]="to"
                                    [inputGroup]="true"
                                    inputGroupIcon="far fa-envelope">
                                </sgt-tokenfield>
                                <sgt-form-control-error
                                    *ngIf="to.errors && to.errors.required && to.dirty"
                                    msgError="É necessário informar o(s) destinatário(s) do e-mail">
                                </sgt-form-control-error>

                                <!-- Opção de selecionar os contatos do cliente-->
                                <div class="container-contatos-to">
                                    <p class="form-text text-muted">
                                        <i class="far fa-envelope" aria-hidden="true"></i> Selecione abaixo os e-mails cadastrados nos contatos do cliente para quem deseja enviar o e-mail do {{entity?.tipoVenda | pedidoTipoVendaSinonimo}}:
                                    </p>
                                    <span
                                        *ngFor="let contato of contatosTo"
                                        class="badge"
                                        [class.badge-secondary]="!contato.adicionado"
                                        [class.badge-primary]="contato.adicionado"
                                        (click)="toggleContatoTo(contato)">
                                            <span *ngIf="contato.nome">{{contato.nome}} -</span> {{contato.email}} <i class="fas fa-check" *ngIf="contato.adicionado"></i>
                                    </span>
                                    <p class="form-text text-muted" *ngIf="!contatosTo || contatosTo.length == 0">
                                        <i class="fas fa-info"></i> Nenhum e-mail cadastrado nos contatos do cliente. Você pode digitar o e-mail manualmente ou cadastrar um novo contato com e-mail.
                                    </p>
                                </div>

                                <!-- Emails Administrativos -->
                                <sgt-usuario-email-administrativo-select
                                    (toggleSelect)="onToggleSelectUsuarioEmailAdministrativo($event)"
                                    #usuarioEmailAdministrativoSelect>
                                </sgt-usuario-email-administrativo-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="cc" class="col-form-label">Cc</label>
                                <sgt-tokenfield
                                    [(ngModel)]="valueObject.cc"
                                    name="cc"
                                    id="cc"
                                    [createTokensOnBlur]="true"
                                    inputType="email"
                                    tokenDuplicateMessage='E-mail "com cópia" já adicionado'
                                    [validateEmail]="true"
                                    #cc="ngModel"
                                    [ngControl]="cc"
                                    [inputGroup]="true"
                                    inputGroupIcon="far fa-envelope">
                                </sgt-tokenfield>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="subject" class="col-form-label">Assunto</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="far fa-comment-dots"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control" [(ngModel)]="valueObject.subject" name="subject" id="subject" #subjectInput>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="message" class="col-form-label">Mensagem</label>
                                <sgt-rich-text-editor
                                  #richTextEditorRef
                                  [(ngModel)]="valueObject.message"
                                  name="message"
                                  id="message"
                                  #message="ngModel"
                                  [control]="message.control"
                                  >
                                </sgt-rich-text-editor>
                                <sgt-form-control-error
                                    *ngIf="message.errors && message.errors.required && message.dirty"
                                    msgError="A mensagem é obrigatória">
                                </sgt-form-control-error>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <div class="alert alert-info alert-anexo">
                                    <p><i class="fas fa-paperclip" aria-hidden="true"></i> A impressão do {{entity?.tipoVenda | pedidoTipoVendaSinonimo}} irá em anexo neste e-mail.</p>
                                    <button type="button" class="btn btn-light" (click)="print()">
                                        <i class="fas fa-print" aria-hidden="true"></i> Visualizar Impressão
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" (click)="cancel()">
                        <i class="fas fa-times"></i> Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" (click)="send()" id="btnSendPedido" [disabled]="form.invalid">
                        <i class="far fa-paper-plane"></i> Enviar
                    </button>
                </div>
            </ng-template>
        </div>
    </div>
</div>
